import React from 'react';

export const PulseRing = ({ percent, size = 96, stroke = 9, color, track = '#e8f6f9', children, testid }) => {
  const r = (size - stroke) / 2;
  const c = 2 * Math.PI * r;
  const p = Math.max(0, Math.min(100, percent || 0));
  return (
    <div className="relative shrink-0" style={{ width: size, height: size }} data-testid={testid}>
      <svg width={size} height={size} className="-rotate-90">
        <circle cx={size / 2} cy={size / 2} r={r} fill="none" stroke={track} strokeWidth={stroke} />
        <circle className="pulse-ring-arc" cx={size / 2} cy={size / 2} r={r} fill="none" stroke={color} strokeWidth={stroke}
          strokeLinecap="round" strokeDasharray={c} strokeDashoffset={c * (1 - p / 100)} />
      </svg>
      <div className="absolute inset-0 flex items-center justify-center font-extrabold">{children ?? `${p}%`}</div>
    </div>
  );
};
